import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const UXGENIE_SLICE_FEATURE_KEY = 'uxgenieSlice';

export interface UXGenieTemplate {
  aiworker_usage_id: string;
  aiworker_id: string;
  title: string;
  aiworker_name: string;
  status: string;
  used_at: string;
  date: string;
  user_id: string;
  user_name: string;
  aiworker_type?: string;
  input_data?: {
    user_input: string;
  };
  output_data?: {
    generated_code?: string;
    generated_schema: string;
    action_name: string;
    saved_at: string;
    output_type?: string;
    storage?: 's3';
    html_file_name?: string;
  };
  created_at?: string;
  updated_at?: string;
}

export interface UXGenieState {
  templates: UXGenieTemplate[];
  isLoading: boolean;
  lastFetched: string | null;
}

const initialState: UXGenieState = {
  templates: [],
  isLoading: false,
  lastFetched: null
};

export const uxgenieSlice = createSlice({
  name: UXGENIE_SLICE_FEATURE_KEY,
  initialState,
  reducers: {
    setTemplates: (state, action: PayloadAction<UXGenieTemplate[]>) => {
      state.templates = action.payload;
      state.lastFetched = new Date().toISOString();
      state.isLoading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    addTemplate: (state, action: PayloadAction<UXGenieTemplate>) => {
      const existingIndex = state.templates.findIndex(
        (t) => t.aiworker_usage_id === action.payload.aiworker_usage_id
      );
      if (existingIndex >= 0) {
        state.templates[existingIndex] = action.payload;
      } else {
        state.templates.push(action.payload);
      }
    },
    clearTemplates: (state) => {
      state.templates = [];
      state.lastFetched = null;
      state.isLoading = false;
    },
  },
});

export const { setTemplates, setLoading: setUXGenieLoading, addTemplate, clearTemplates } = uxgenieSlice.actions;

export default uxgenieSlice.reducer;

